import { useAppSelector } from '@store/hooks';
import { selectOverviewItems } from '@store/mainReducer';
import React from 'react';
import { useViewportMode } from '@utils/useMobileDetection';

const RefreshDate = () => {
  const {lastUpdate} = useAppSelector(selectOverviewItems);
  const { isTablet } = useViewportMode();

  return (
    <div className={`text-white ${isTablet ? 'text-[10px]' : ''}`}>
      <span className='text-xs'>Derniere mise a jour :</span>
      <span>{` ${lastUpdate}`}</span>
    </div>
  )
}

export default RefreshDate
